import React from "react";
import { Form, Input } from "antd";
import AuthorizationWrapper from "src/common/AuthorizationWrapper";
import { AdminPermissions } from "src/common/Permissions";

interface IProps {
	reportSetting: ReportSettingDTO;
	children?: any;
	onReportSettingChange: any;
}

const WhiteLabelingForm = (props: IProps) => {
	const { reportSetting, onReportSettingChange } = props;
	const {
		primaryColor = "#FFFFFF",
		secondaryColor = "#000000",
	} = reportSetting;
	return (
		<React.Fragment>
			<div className="row">
				<div className="form-group col-2">
					<label>Primary colour</label>
					<Form.Item hasFeedback={true}>
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationReportSetting]}
						>
							<div className="input-group">
								<div className="input-group-prepend">
									<input
										style={{ height: "auto" }}
										type="color"
										value={primaryColor}
										onChange={onReportSettingChange}
										name="primaryColor"
									/>
								</div>
								<Input
									style={{ flex: 1 }}
									className="form-control"
									type="text"
									value={primaryColor}
									onChange={onReportSettingChange}
									name="primaryColor"
								/>
							</div>
						</AuthorizationWrapper>
					</Form.Item>
				</div>
				<div className="form-group col-2">
					<label>Secondary colour</label>
					<Form.Item hasFeedback={true}>
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationReportSetting]}
						>
							<div className="input-group">
								<div className="input-group-prepend">
									<input
										style={{ height: "auto" }}
										type="color"
										value={secondaryColor}
										onChange={onReportSettingChange}
										name="secondaryColor"
									/>
								</div>
								<Input
									style={{ flex: 1 }}
									className="form-control"
									type="text"
									value={secondaryColor}
									onChange={onReportSettingChange}
									name="secondaryColor"
								/>
							</div>
						</AuthorizationWrapper>
					</Form.Item>
				</div>
				<div className="form-group col-2">
					<label>Change VITALS (Legacy) to</label>
					<Form.Item hasFeedback={true}>
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationReportSetting]}
						>
							<Input
								defaultValue="A"
								name="vitalsReplacementText"
								value={reportSetting.vitalsReplacementText}
								onChange={onReportSettingChange}
							/>
						</AuthorizationWrapper>
					</Form.Item>
				</div>
				<div className="form-group col-2">
					<label>Change CORE to</label>
					<Form.Item hasFeedback={true}>
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationReportSetting]}
						>
							<Input
								defaultValue="A"
								name="coreReplacementText"
								value={reportSetting.coreReplacementText}
								onChange={onReportSettingChange}
							/>
						</AuthorizationWrapper>
					</Form.Item>
				</div>
				<div className="form-group col-2">
					<label>Change EXCELERATE to</label>
					<Form.Item hasFeedback={true}>
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationReportSetting]}
						>
							<Input
								defaultValue="A"
								name="excelerateReplacementText"
								onChange={onReportSettingChange}
								value={reportSetting.excelerateReplacementText}
							/>
						</AuthorizationWrapper>
					</Form.Item>
				</div>
				<div className="form-group col-2">
					<label>Change Vitals to</label>
					<Form.Item hasFeedback={true}>
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationReportSetting]}
						>
							<Input
								defaultValue="A"
								name="careReplacementText"
								onChange={onReportSettingChange}
								value={reportSetting.careReplacementText}
							/>
						</AuthorizationWrapper>
					</Form.Item>
				</div>
			</div>
			<div className="row">
				<div className="col-5 form-group">
					<label>Disclaimer</label>
					<Form.Item>
						<AuthorizationWrapper
							type="disable"
							permissions={[AdminPermissions.EditOrganizationReportSetting]}
						>
							<Input.TextArea
								name="disclaimer"
								rows={4}
								value={reportSetting.disclaimer}
								onChange={onReportSettingChange}
								placeholder="Enter a disclaimer statement"
							/>
						</AuthorizationWrapper>
					</Form.Item>
				</div>
			</div>
		</React.Fragment>
	);
};

export default WhiteLabelingForm;
